package one.devsbox.www.ui.uploader

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import tk.mallumo.compose.navigation.LocalNavigation
import tk.mallumo.compose.navigation.Navigation
import tk.mallumo.compose.navigation.viewmodel.globalViewModel

class UploaderCtx private constructor(
    val vm: UploaderVM,
    val nav: Navigation
) {
    val action get() = vm.action

    companion object {
        @Composable
        fun get(): UploaderCtx {
            val nav = LocalNavigation.current
            val vm = globalViewModel(UploaderVM::class)
            return remember {
                UploaderCtx(vm, nav).apply {
                    vm.setup(this)
                }
            }
        }
    }
}
